exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.social[data-v-f817d436] .v-image__image--cover, .v-image__image[data-v-f817d436]{\n  background-size: contain !important;\n}\n", ""]);

// exports
